module.exports = __webpack_public_path__ + "img/icon_resume.c19f694d.svg";